import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { IecSchedulingData } from '../model/iec-scheduling-data';
import { GoogleService } from './google-service';

@Service()
export class IecSchedulingDataService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);
  private readonly urlBase: string = environment.serviceUrl + 'schedulingData/';

  getSchedulingData(entityId: string, revision: number): Observable<IecSchedulingData> {
    const url = this.urlBase + entityId + '/' + revision;
    return this.http.get<IecSchedulingData>(url, { headers: this.getRequestHeaders() });
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }
}
